// JsFromRoutes CacheKey 126c5a73788974005c398702e256d0a1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/images/:signed_id'),
}
